import {Hls} from 'hls.js'

document.initHls = function () {
    let videos = document.getElementsByClassName('course-video');

    Array.prototype.forEach.call(videos, function (video) {
        let videoData = video.dataset;
        let videoSrc = videoData.hlspath;

        if (videoSrc.length && Hls.isSupported()) {
            let hls = new Hls();
            hls.loadSource(videoSrc);
            hls.attachMedia(video);
        }
            // HLS.js is not supported on platforms that do not have Media Source
            // Extensions (MSE) enabled.
            //
            // When the browser has built-in HLS support (check using `canPlayType`),
            // we can provide an HLS manifest (i.e. .m3u8 URL) directly to the video
            // element through the `src` property. This is using the built-in support
// of the plain video element, without using HLS.js.
        else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            video.src = videoSrc;
        }
    });
}
